// extracted by mini-css-extract-plugin
module.exports = {"root":"separator_root__K7StR","orientationhorizontal":"separator_orientationhorizontal__tSyZU","orientationvertical":"separator_orientationvertical__mrln2"};